import { GamesStorageType, LiveDataGamesArr } from '../../types';

type SetGamesLiveDataStatePreparator = (args: {
  state: GamesStorageType;
  liveDataGamesArr: LiveDataGamesArr;
}) => GamesStorageType;

export const setGamesLiveDataStatePreparator: SetGamesLiveDataStatePreparator =
  ({ state, liveDataGamesArr }) => {
    const newLaunchIdToGameLiveData = liveDataGamesArr.reduce(
      (acc, item = {}) => {
        // internalGameId is a launchId
        if (!item.internalGameId) {
          return acc;
        }
        return {
          ...acc,
          [item.internalGameId]: {
            ...item
          }
        };
      },
      state.gamesLiveInfo.launchIdToGameLiveData
    );
    return {
      ...state,
      gamesLiveInfo: {
        ...state.gamesLiveInfo,
        launchIdToGameLiveData: newLaunchIdToGameLiveData
      }
    };
  };
